import request from '@/utils/request'

export function SetBinding(data) {
    return request({
        url: '/api/WechatUser/SetBinding',
        method: 'post',
        data
    })
}

export function GetPage(data) {
    return request({
        url: '/api/WechatUser/GetPage',
        method: 'get',
        params: data
    })
}


